import { NavigationMenuVisibilityContext } from '../../components/NavigationPanel/NavigationMenuVisibilityContext';
import { isWeb } from '../../config/designSystem/Layout';
import { privateKey } from '../../constants/routeKeys';
import { useBreakpoint } from '../useBreakpoint';
import { useContext } from 'react';
import { useSegments } from 'expo-router';

export const useIsSmallWeb = () => {

  const isSmall = useBreakpoint().sm;
  const { visible } = useContext(NavigationMenuVisibilityContext);
  const segments = useSegments();
  return{
    isSmallWeb: isWeb && isSmall,
    isLargeEnoughForLateralBarWeb : isWeb && !isSmall,
    hasLateralBar: isWeb && !isSmall && segments.includes(privateKey) && visible
  };

};